var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.customers,"loading":_vm.loading},scopedSlots:_vm._u([{key:"item.actions",fn:function({ item }){return [_c('v-icon',{attrs:{"small":"","color":"error"},on:{"click":function($event){return _vm.deleteCustomer(item)}}},[_vm._v("mdi-delete")])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }